import React, { useContext } from 'react'
import { Table } from 'components'
import { createAssessmentsHooks } from '.'
import { dataGridModel } from 'keys'
import { CreateAssessmentsContext } from './CreateAssessmentsContext'

const FlatTestTakers = () => {
    const {
        selectedTestTakers, setSelectedTestTakers,
        testTakersFlatList, learningGroupStructureOptions,
        searchVal, setSearchVal, sorting, setSorting } = useContext(CreateAssessmentsContext)
    const testTakersColumns = createAssessmentsHooks.useTestTakersTableColumns()


    return (
        <div className='school-classes-table'>
            <Table
                tableH={"100%"}
                withTitle
                loading={testTakersFlatList.isFetching}
                data={{ results: testTakersFlatList.data || [] }}
                columns={testTakersColumns}
                searchVal={searchVal}
                setSearchVal={setSearchVal}
                sorting={sorting}
                setSorting={setSorting}
                hideSorting
                hidePagination
                hideToolbar
                hideVisibilityColumns
                queryKey={learningGroupStructureOptions.queryKey}
                visibilityModelKey={dataGridModel.school_classes}
                selectedRowIds={selectedTestTakers} // האובייקט של ה-State { id: true }
                setSelectedRowIds={setSelectedTestTakers} // פונקציית העדכון
                onRowSelection={setSelectedTestTakers}
            />
        </div>
    )
}

export default FlatTestTakers